// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__1ba5R","loader":"Loader_loader__ehzTp","spin":"Loader_spin__1Yo3B"};